import styled from "styled-components";
export const CardProductHeader = styled.header.withConfig({
    displayName: "styled__CardProductHeader",
    componentId: "sc-d88eafbe-0"
})`
	display: grid;
	grid-template-columns: repeat(3, 33%);
	grid-template-rows: repeat(3, 33%);
	gap: 2px;
	border-bottom: 1px solid ${({ theme  })=>theme.colors.grays.lighter};

	.ship {
		grid-area: 1 / 1 / 3 / 2;
	}

	.logo {
		grid-area: 3 / 1 / 4 / 2;
	}

	.itinerary {
		grid-area: 1 / 2 / 4 / 4;
	}

	img {
		width: 100%;
	}
`;

//# sourceMappingURL=styled.js.map